import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-direct-link-topbar',
    templateUrl: './direct-link-topbar.component.html',
    styleUrls: ['./direct-link-topbar.component.scss'],
    standalone: false
})
export class DirectLinkTopbarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
